const _ = require('lodash');

export const formatData = (columns, rows) => rows.map(row => columns.reduce((obj, curr, index) => ({ ...obj, [curr]: _.defaultTo(row[index], '') }), {}));
